import {Label} from "@atlaskit/form";
import type {ComponentProps} from "react";

export function AnankeLabel({
    children,
    htmlFor = "",
    isRequired,
    ...props
    //
}: Omit<ComponentProps<typeof Label>, "htmlFor"> & {isRequired?: boolean; htmlFor?: string}) {
    return (
        <Label
            {...props}
            htmlFor={htmlFor}
        >
            {children}
            {isRequired === true && (
                <span className="text-ds-text-danger pl-ds-space-025 text-ds-font-body !font-ds-font-weight-bold">
                    *
                </span>
            )}
        </Label>
    );
}
